import { CREATE_NOTIFICATION_RULE_URL, GET_NOTIFICATION_PRIORITY_URL , GET_NOTIFICATION_EVENT_TRIGGER_URL} from "@/utils/system_constants/constant";
import axios from "axios";
import { get_request_config } from "@/utils/system_constants/constant";
import NotificationStepper from "@/components/config_components/notifications/notification.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';

function get_notification_error_message(error, fallback) {
  return error.response?.data?.message || error.message || fallback;
}

export default {
  name: 'NotificationManagement',
  mixins: [alert_mixin],
  components: {
    NotificationStepper,
  },

  data: () => ({
    priority_options: [],
    event_trigger_options: [],  
    notification: {
    name: "",
    description: "",
    event_trigger:"",
    priority: "Normal",
    is_active: true,
    event_source: "",
    channels: [],
},
  notification_message: {
   email: {
    subject: "",
    body: "",
},
sms: {
    message: "",
},
in_app: {
    title: "",
    message: "",
},
webhook: {
    url: "",
    payload: "",
},
  },
      loading: false,
     entity_types: [],
     entity_configs: [],
     selected_entity_type: "",
     selected_entity_configs: [],
     priority: "",

      active_step: 1,
      selected_channels: [],
      recipient_groups: [
        { type: "", 
          role_id: "", 
          user_id: "",
          cc: false, 
          required: true
         } // start with one select group
      ],
      conditions: [
        { entity_type: "", operator: "equals", value: "" } // start with one condition row
      ],
      errors: {}    
  }),
 mounted() {
    this.get_notification_priorities();
    this.get_notification_event_triggers();   
},
  computed: {
    hasEmail() {
        return this.selected_channels.includes("email");
    },
    hasSMS() {
        return this.selected_channels.includes("sms");
    },
    hasInApp() {
        return this.selected_channels.includes("in_app");
    },
    hasWebhook() {
        return this.selected_channels.includes("webhook");
    }
},
  methods: {
    nextStep() {
      if (this.validateStep()) {
        if (this.active_step < 5) {
          this.active_step++;
        }
      }
    },
    previous_step() {
      if (this.active_step > 1) {
        this.active_step--;
      }
    },
    add_recipient_group() {
    this.recipient_groups.push({
        type: "",
        role_id: "",
        user_id: "",
        cc: false,
        required: true
    });
},
    remove_recipient(index) {
      this.recipient_groups.splice(index, 1);
    },
    add_condition() {
      this.conditions.push({ entity_type: "", operator: "equals", value: "" });
    },
    remove_condition(index) {
      this.conditions.splice(index, 1);
    },

   async create_notification_rule() {
    this.loading = true;
    this.errors = {};

    try {
        const payload = {
            name: this.notification.name,
            description: this.notification.description,
            priority: this.notification.priority,
            is_active: this.notification.is_active,
        };

        const { data } = await axios.post(
            CREATE_NOTIFICATION_RULE_URL,
            payload,
            get_request_config()
        );

        if (data?.status === "success") {
            this.notification.id = data.data.id;
            this.show_success(data.message || "Notification saved successfully.");
            return;
        }
        this.show_error(data.message || "Failed to save notification.");

    } catch (error) {

        if (error.response?.data?.errors) {
            this.errors = error.response.data.errors;
        }

        const errorMessage =
            error.response?.data?.message || error.message || "Failed to save notification.";
        this.show_error(errorMessage);

    } finally {
        this.loading = false;
    }
},
async get_notification_priorities() {
    const response = await axios
        .get(GET_NOTIFICATION_PRIORITY_URL, get_request_config())
        .catch((error) => {
            this.show_error(
                get_notification_error_message(
                    error,
                    "Failed to load notification priorities."
                )
            );
            return null;
        })
        .finally(() => (this.loading = false));

    if (!response) {
        return;
    }

    const { data } = response;
    if (data?.status === "success") {
        this.priority_options = data.data || [];
        return;
    }

    this.show_error(data?.message || "Failed to load notification priorities.");
},
async get_notification_event_triggers() {
    const response = await axios
        .get(GET_NOTIFICATION_EVENT_TRIGGER_URL, get_request_config())
        .catch((error) => {
            this.show_error(
                get_notification_error_message(
                    error,
                    "Failed to load notification event triggers."
                )
            );
            return null;
        });

    if (!response) {
        return;
    }

    const { data } = response;
    if (data?.status === "success") {
        this.event_trigger_options = data.data || [];
        return;
    }

    this.show_error(
        data?.message || "Failed to load notification event triggers."
    );
},
  },
  validateStep() {
      this.errors = {};

      if (this.active_step === 1) {
        if (!this.notification.name) {
          this.errors.name = "Name is required.";
        }

        if (!this.notification.priority) {
          this.errors.priority = "Priority is required.";
        }
      }

      return true;
    },
}
